<app-company-page-layout gridTemplateColumns="3fr 2fr">
  <div class="header">
    <h4 class="title">{{trans('settings.labels.regions')}}</h4>
    <app-icon-button [routerLink]="[companyRootRoute + '/settings/regions/new']" [label]="trans('settings.labels.addRegion')" icon="assets/images/company/plus.svg"></app-icon-button>
    <app-company-columns [items]="columnConfig" [(value)]="columns.value" #cols></app-company-columns>
  </div>
  <app-regions-data-table [columns]="columns.value" (modifyColumns)="cols.show()"></app-regions-data-table>
</app-company-page-layout>
